.root {
  position: fixed;
  left: 20px;
  z-index: var(--z-index-download-activity, var(--z-index-toast));
}

.wrap {
  padding: 10px;
  background-color: var(--pri-01);
  border-radius: 5px;
  overflow: hidden;
  box-shadow: var(--shadow);
}

.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  min-height: 90px;
  width: 300px;
}

/* The progress row is gone once a transfer settles, so the card shouldn't keep holding
   space for it. Stays under the 110px stride `.root` uses to stack items. */
.settled {
  min-height: 0;
}

.settled .title {
  margin-bottom: 8px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  color: var(--black-l);
}

.content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.info {
  width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.icon {
  flex: 0 0 40px;
}

.error-icon {
  color: var(--pri-04);
  font-size: 30px;
}

.stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 10px 0;
}

/* Two steps only: 16px for the status, 14px for everything describing it. */
.title {
  font-family: var(--font-semibold);
  color: var(--black);
  font-size: 16px;
  line-height: 21px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.name {
  font-family: var(--font-reg);
  color: var(--black-l);
  font-size: 14px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reason {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-family: var(--font-reg);
  color: var(--pri-04);
  font-size: 14px;
  line-height: 18px;
  margin-top: 3px;
  overflow: hidden;
  /* Overrides the single-line rule on `.info`, which exists for the filename. */
  white-space: normal;
}

.percent {
  font-family: var(--font-reg);
  font-size: 15px;
  color: var(--pri-02);
}

.bar {
  position: relative;
  height: 9px;
  width: 150px;
  background-color: var(--gray-l);
  border-radius: 5px;
  overflow: hidden;
}

.one {
  position: absolute;
  left: 0px;
  bottom: 0px;
  top: 0px;
  transition: transform 0.2s linear 0s;
  transform-origin: left center;
  width: auto;
  background-color: var(--pri-03);
  animation: 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) 0s infinite normal none running elastic;
}

.two {
  position: absolute;
  left: 0px;
  bottom: 0px;
  top: 0px;
  transition: transform 0.2s linear 0s;
  transform-origin: left center;
  width: auto;
  background-color: var(--pri-03);
  animation: 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite normal none running lag;
}

@keyframes elastic {
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
}

@keyframes lag {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}

.cancel {
  font-family: var(--font-reg);
  font-size: 14px;
  color: var(--hyperlink);
  text-decoration: underline;
}

.transferring {
  animation-duration: 225ms;
  animation-name: remove;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-delay: 500ms;
}

@keyframes remove {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
